import type { ReactNode } from 'react';

import { cn } from '@mds/shared/lib/utils';

interface Props {
  title?: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
}

/** A titled panel. The header only renders when a `title` or `action` is given. */
export default function Card({ title, action, children, className }: Props) {
  return (
    <section
      className={cn('rounded-2xl border border-hairline bg-surface p-4 shadow-card sm:p-6', className)}
    >
      {(title || action) && (
        <header className="mb-4 flex flex-wrap items-center justify-between gap-3 sm:mb-5 sm:gap-4">
          {title && <h2 className="m-0 text-lg font-semibold tracking-tight">{title}</h2>}
          {action}
        </header>
      )}
      {children}
    </section>
  );
}
